import React, { useState, useEffect } from 'react';
import { ModalEffect } from '../../../types/modal.mjs';
import { StyledWrapper, StyledContainer, StyledModalCloseButton, StyledHeading } from './Modal.styles.mjs';

// On theme.ts we have a max animation time is 400ms. The timeout is max animation time + buffer
const MODAL_CLOSING_TIMEOUT = 500;
const Modal = ({ children, className, effect = ModalEffect.SCALE_FADE, enableOverlay, title, onClose }) => {
    const [isModalShown, setIsModalShown] = useState(false);
    useEffect(() => {
        setIsModalShown(true);
    }, []);
    useEffect(() => {
        const timeout = isModalShown ? null : setTimeout(onClose, MODAL_CLOSING_TIMEOUT);
        return () => {
            if (timeout)
                clearTimeout(timeout);
        };
    }, [isModalShown]);
    const handleClose = () => {
        setIsModalShown(false);
    };
    return (React.createElement(StyledWrapper, { enableOverlay: enableOverlay },
        React.createElement(StyledContainer, { className: className, effect: effect, isModalShown: isModalShown },
            React.createElement(StyledModalCloseButton, { type: "button", iconType: "close", onClick: handleClose }),
            React.createElement(StyledHeading, { tag: "h2" }, title),
            children)));
};

export { Modal as default };
//# sourceMappingURL=Modal.mjs.map
